import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";

import { registerNavSection } from "./shell/navigation";

registerNavSection({ key: "finance", spoke: "finance", title: "Finance", icon: AccountBalanceOutlinedIcon, order: 55, entries: [
  { label: "Overview", to: "/app/finance", permission: "finance.gl.view" },
  { label: "Journals", to: "/app/finance/journals", permission: "finance.gl.view" },
  { label: "Statements", to: "/app/finance/statements", permission: "finance.gl.view" },
  { label: "Periods & close", to: "/app/finance/periods", permission: "finance.gl.view" },
  { label: "Budgets", to: "/app/finance/budgets", permission: "finance.gl.view" },
  { label: "Customer invoices", to: "/app/finance/invoices", permission: "finance.ar.view" },
  { label: "Cash receipts", to: "/app/finance/receipts", permission: "finance.ar.view" },
  { label: "Receivables & collections", to: "/app/finance/collections", permission: "finance.ar.view" },
  { label: "Vendor invoices", to: "/app/finance/vendor-invoices", permission: "finance.ap.view" },
  { label: "Payment runs", to: "/app/finance/payment-runs", permission: "finance.ap.view" },
  { label: "Bank & cash", to: "/app/finance/bank", permission: "finance.cash.view" },
  { label: "Costing & WIP", to: "/app/finance/costing", permission: "finance.costing.view" },
  { label: "Fixed assets", to: "/app/finance/fixed-assets", permission: "finance.costing.view" },
  { label: "Chart of accounts", to: "/app/masterdata/gl-accounts", permission: "finance.gl.view" },
  { label: "Posting rules", to: "/app/masterdata/posting-rules", permission: "finance.gl.view" },
] });
